import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../Card';
import { Bot, Clock, CheckCircle2 } from 'lucide-react';
import { Button } from '../Button';
import { toast } from 'sonner';
const recs = [{
  id: 1,
  action: 'Klarifikasi deepfake audio Presiden di TikTok',
  pic: 'KOMDIGI',
  deadline: '4 jam'
}, {
  id: 2,
  action: 'Rilis data resmi distribusi bansos pangan',
  pic: 'KEMENSOS',
  deadline: '8 jam'
}, {
  id: 3,
  action: 'Review pengamanan digital kunjungan Papua',
  pic: 'PASPAMPRES',
  deadline: '12 jam'
}, {
  id: 4,
  action: 'Takedown akun impersonation di X',
  pic: 'KOMDIGI',
  deadline: '24 jam'
}];
export function Recommendations() {
  const handleApprove = (id: number, action: string) => {
    toast.success('Rekomendasi disetujui', {
      description: `Tugas "${action}" telah diteruskan ke PIC terkait.`
    });
  };
  return <Card className="bg-card border-border/50" data-id="element-865">
      <CardHeader className="pb-2 pt-4 px-4 border-b border-border/50 bg-primary/5" data-id="element-866">
        <CardTitle className="font-mono text-xs uppercase tracking-wider text-primary flex items-center gap-2" data-id="element-867">
          <Bot className="size-4" data-id="element-868" />
          Rekomendasi 24 Jam (AI Analyst)
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0" data-id="element-869">
        <div className="flex flex-col divide-y divide-border/50" data-id="element-870">
          {recs.map(rec => <div key={rec.id} className="p-3 flex items-start gap-3 hover:bg-muted/10 group" data-id="element-871">
              <span className="font-mono text-xs text-muted-foreground mt-0.5" data-id="element-872">
                {rec.id}.
              </span>
              <div className="flex-1" data-id="element-873">
                <p className="text-xs font-medium text-foreground" data-id="element-874">
                  {rec.action}
                </p>
                <div className="flex items-center justify-between mt-1.5" data-id="element-875">
                  <div className="flex items-center gap-3" data-id="element-876">
                    <span className="font-mono text-[9px] px-1.5 py-0.5 bg-muted rounded text-muted-foreground border border-border/50" data-id="element-877">
                      {rec.pic}
                    </span>
                    <span className="flex items-center gap-1 font-mono text-[9px] text-amber-500" data-id="element-878">
                      <Clock className="size-3" data-id="element-879" />
                      Batas: {rec.deadline}
                    </span>
                  </div>
                  <Button variant="ghost" size="xs" className="h-5 px-2 text-[9px] font-mono text-emerald-500 hover:bg-emerald-500/10 hover:text-emerald-500 opacity-0 group-hover:opacity-100 transition-opacity" onClick={() => handleApprove(rec.id, rec.action)} data-id="element-880">
                    <CheckCircle2 className="size-3 mr-1" data-id="element-881" /> Setujui
                  </Button>
                </div>
              </div>
            </div>)}
        </div>
      </CardContent>
    </Card>;
}